export const downHeight = function (key, step = 5) {
  const value = typeof this.values[key] === "number" ? this.values[key] : key
  return `@media (max-height:${value - step / 100}${this.unit})`
}

export const upHeight = function (key) {
  const value = typeof this.values[key] === "number" ? this.values[key] : key
  return `@media (min-height:${value}${this.unit})`
}
